import React, { useState, useEffect } from "react";
import Header from "../../Components/Onboarding-Header/header";
import Sidebar from "../../Components/Onboarding.sidebar/onboarding-sidebar";
import {
  steps,
  stepsCorporate,
  stepsTrust,
  stepsJointAccount,
} from "../../Constants/config";
import PersonalInfo from "./Steps/personal-info";
import BusinessInfo from "./Steps/business-info";
import ProofInfo from "./Steps/proof-info";
import LinkAccount from "./Steps/link-account";
import CashAccount from "./Steps/cash-account";
import UploadProof from "./Steps/upload-proof";
import ReviewSubmit from "./Steps/review-submit";
import CorporateInfo from "./Corporate-steps/corporate-info";
import DirectorInfo from "./Corporate-steps/directors-info";
import UploadProofCorporate from "./Corporate-steps/upload-proof-corporate";
import ReviewSubmitCorporate from "./Corporate-steps/review-submit-corporate";
import TrustInfo from "./Trust-steps/trust-info";
import TrusteeInfo from "./Trust-steps/trustee-info";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  setCurrentStepRedux,
  setCurrentStepCorprateRedux,
  setCurrentStepTrustRedux,
  setStepStatus,
  setRejectedFields,
  clearStepStatusShareholder,
} from "../../Redux/store/onboardingFormSlice";
import UploadProofTrust from "./Trust-steps/upload-proof-trust";
import ReviewSubmitTrust from "./Trust-steps/review-submit-trust";
import {
  setApplicationTypeShareHolder,
  clearApplicationTypeShareHolder,
} from "../../Redux/store/accountTypeSlice";
import { useToast } from "../../Utils/toastContext";

const stepMappingSoleTrader = {
  PERSONAL_INFO: 1,
  BUSINESS_INFO: 2,
  PROOF_ITS_YOU: 3,
  EXTERNAL_BANKS: 4,
  CASH_ACCOUNTS: 5,
  UPLOAD_PROOF_DOCS: 6,
  REVIEW_AND_SUBMIT: 7,
};
const stepMappingIndividual = {
  PERSONAL_INFO: 1,
  PROOF_ITS_YOU: 2,
  EXTERNAL_BANKS: 3,
  CASH_ACCOUNTS: 4,
  UPLOAD_PROOF_DOCS: 5,
  REVIEW_AND_SUBMIT: 6,
};

const stepMappingJointAccount = {
  PERSONAL_INFORMATION: 1,
  PROOF_ITS_YOU: 2,
  UPLOAD_PROOF_DOCS: 3,
  REVIEW_AND_SUBMIT: 4,
};
const stepMappingCorporate = {
  CORPORATE_INFORMATION: 1,
  DIRECTORS_SHAREHOLDERS: 2,
  EXTERNAL_BANKS: 3,
  CASH_ACCOUNTS: 4,
  UPLOAD_PROOF_DOCS: 5,
  REVIEW_AND_SUBMIT: 6,
};
const stepMappingTrust = {
  TRUST_INFORMATION: 1,
  TRUSTEES_BENEFICIARIES: 2,
  EXTERNAL_BANKS: 3,
  CASH_ACCOUNTS: 4,
  UPLOAD_PROOF_DOCS: 5,
  REVIEW_AND_SUBMIT: 6,
};
const MultiStepSidebarForm = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const dispatch = useDispatch();
  const { showToast } = useToast();

  const navigate = useNavigate();
  const currentStepRedux = useSelector((state) => state.form.currentStep);
  const [currentStep, setCurrentStep] = useState(Number(currentStepRedux));
  const individualAccountType = useSelector(
    (state) => state.form.individualAccountType,
  );

  const [currentStepJointAccount, setCurrentStepJointAccount] = useState(
    Number(currentStepRedux),
  );
  const currentStepCorporateRedux = useSelector(
    (state) => state.form.currentStepCorprate,
  );

  const [currentStepCorporate, setCurrentStepCorporate] = useState(
    Number(currentStepCorporateRedux),
  );
  const currentStepTrustRedux = useSelector(
    (state) => state.form.currentStepTrust,
  );

  const [currentStepTrust, setCurrentStepTrust] = useState(
    Number(currentStepTrustRedux),
  );
  const isInvitee = useSelector((state) => state.user.isInvitee);
  const isInviteeDirector = useSelector(
    (state) => state.user.isInviteeDirector,
  );

  const applicationType = useSelector(
    (state) => state.accountType.applicationType,
  );
  const isSoleTrader = individualAccountType === 5;

  const individualSteps = isSoleTrader
    ? [
        { id: 1, title: "Personal Information" },
        { id: 2, title: "Business Information" },
        { id: 3, title: "Prove It's You" },
        { id: 4, title: "Link External Account" },
        { id: 5, title: "Cash Account" },
        { id: 6, title: "Upload Proof Doc" },
        { id: 7, title: "Review & Submit" },
      ]
    : [
        { id: 1, title: "Personal Information" },
        { id: 2, title: "Prove It's You" },
        { id: 3, title: "Link External Account" },
        { id: 4, title: "Cash Account" },
        { id: 5, title: "Upload Proof Doc" },
        { id: 6, title: "Review & Submit" },
      ];

  const renderStepContent = () => {
    dispatch(setCurrentStepRedux(currentStep));

    const stepMap = isSoleTrader
      ? {
          1: <PersonalInfo setCurrentStep={setCurrentStep} />,
          2: <BusinessInfo setCurrentStep={setCurrentStep} />,
          3: <ProofInfo setCurrentStep={setCurrentStep} />,
          4: (
            <LinkAccount
              setCurrentStep={setCurrentStep}
              applicationType={applicationType}
            />
          ),
          5: (
            <CashAccount
              setCurrentStep={setCurrentStep}
              applicationType={applicationType}
            />
          ),
          6: <UploadProof setCurrentStep={setCurrentStep} />,
          7: <ReviewSubmit setCurrentStep={setCurrentStep} />,
        }
      : {
          1: <PersonalInfo setCurrentStep={setCurrentStep} />,
          2: <ProofInfo setCurrentStep={setCurrentStep} />,
          3: (
            <LinkAccount
              setCurrentStep={setCurrentStep}
              applicationType={applicationType}
            />
          ),
          4: (
            <CashAccount
              setCurrentStep={setCurrentStep}
              applicationType={applicationType}
            />
          ),
          5: <UploadProof setCurrentStep={setCurrentStep} />,
          6: <ReviewSubmit setCurrentStep={setCurrentStep} />,
        };

    return stepMap[currentStep] || <div>Step not found</div>;
  };

  // useEffect(() => {
  //   setCurrentStep(1);
  //   dispatch(setCurrentStepRedux(1));
  // }, [individualAccountType]);
  const renderStepContentJointAccount = () => {
    dispatch(setCurrentStepRedux(currentStepJointAccount));
    switch (currentStepJointAccount) {
      case 1:
        return <PersonalInfo setCurrentStep={setCurrentStepJointAccount} />;
      case 2:
        return <ProofInfo setCurrentStep={setCurrentStepJointAccount} />;
      case 3:
        return <UploadProof setCurrentStep={setCurrentStepJointAccount} />;
      case 4:
        return <ReviewSubmit setCurrentStep={setCurrentStepJointAccount} />;
      default:
        return <div>Step not found</div>;
    }
  };
  const renderStepContentCorporate = () => {
    dispatch(setCurrentStepCorprateRedux(currentStepCorporate));
    switch (currentStepCorporate) {
      case 1:
        return <CorporateInfo setCurrentStep={setCurrentStepCorporate} />;
      case 2:
        return <DirectorInfo setCurrentStep={setCurrentStepCorporate} />;
      case 3:
        return (
          <LinkAccount
            setCurrentStep={setCurrentStepCorporate}
            applicationType={applicationType}
          />
        );
      case 4:
        return (
          <CashAccount
            setCurrentStep={setCurrentStepCorporate}
            applicationType={applicationType}
          />
        );
      case 5:
        return (
          <UploadProofCorporate setCurrentStep={setCurrentStepCorporate} />
        );
      case 6:
        return (
          <ReviewSubmitCorporate setCurrentStep={setCurrentStepCorporate} />
        );
      default:
        return <div>Step not found</div>;
    }
  };
  const renderStepContentTrust = () => {
    dispatch(setCurrentStepTrustRedux(currentStepTrust));
    switch (currentStepTrust) {
      case 1:
        return <TrustInfo setCurrentStep={setCurrentStepTrust} />;
      case 2:
        return <TrusteeInfo setCurrentStep={setCurrentStepTrust} />;
      case 3:
        return (
          <LinkAccount
            setCurrentStep={setCurrentStepTrust}
            applicationType={applicationType}
          />
        );
      case 4:
        return (
          <CashAccount
            setCurrentStep={setCurrentStepTrust}
            applicationType={applicationType}
          />
        );
      case 5:
        return <UploadProofTrust setCurrentStep={setCurrentStepTrust} />;
      case 6:
        return <ReviewSubmitTrust setCurrentStep={setCurrentStepTrust} />;
      default:
        return <div>Step not found</div>;
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const getOnboardingStatus = async () => {
    try {
      const response = await GetAPIcalls(`/v1/onboarding/status`);
      if (response.status == 200) {
        if (response.data.length > 0) {
          dispatch(setStepStatus(response.data));

          // find first PENDING section
          let targetSection = response.data.find(
            (item) => item.status === "PENDING" || item.status === "REJECTED",
          );

          // if no PENDING found, fallback to first DRAFT
          if (!targetSection) {
            targetSection = response.data.find(
              (item) => item.status === "DRAFT",
            );
          }

          // if no PENDING found, fallback to Review
          if (!targetSection) {
            targetSection =
              applicationType == 1 ? response.data[6] : response.data[5];
          }
          if (!isInvitee && !isInviteeDirector) {
            // set current step if section found in mapping
            if (applicationType == 1) {
              const isSoleTrader = individualAccountType === 5;

              const individualStepMapping = isSoleTrader
                ? stepMappingSoleTrader
                : stepMappingIndividual;
              if (
                targetSection &&
                individualStepMapping[targetSection.section]
              ) {
                const stepNumber = individualStepMapping[targetSection.section];
                setCurrentStep(stepNumber);
                dispatch(setCurrentStepRedux(stepNumber));
              }
            }
            if (applicationType == 2) {
              if (
                targetSection &&
                stepMappingCorporate[targetSection.section]
              ) {
                const stepNumber = stepMappingCorporate[targetSection.section];
                setCurrentStepCorporate(stepNumber);
                dispatch(setCurrentStepCorprateRedux(stepNumber));
              }
            }
            if (applicationType == 3) {
              if (targetSection && stepMappingTrust[targetSection.section]) {
                const stepNumber = stepMappingTrust[targetSection.section];
                setCurrentStepTrust(stepNumber);
                dispatch(setCurrentStepTrustRedux(stepNumber));
              }
            }
          } else {
            // set current step if section found in mapping
            if (
              targetSection &&
              stepMappingJointAccount[targetSection.section]
            ) {
              const stepNumber = stepMappingJointAccount[targetSection.section];
              setCurrentStepJointAccount(stepNumber);
              dispatch(setCurrentStepRedux(stepNumber));
            }
          }
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      showToast(err.message, "error");
    } finally {
    }
  };
  const getRejectedField = async () => {
    try {
      const response = await GetAPIcalls(`/v1/onboarding/rejected-fields`);
      if (response.status == 200) {
        dispatch(setRejectedFields(response.data)); // <-- Save in Redux
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    getOnboardingStatus();
    getRejectedField();
    // dispatch(clearApplicationTypeShareHolder());
    // dispatch(clearStepStatusShareholder());
  }, []);
  return (
    <div className="min-h-screen">
      <Header
        setCurrentStep={
          applicationType == 1
            ? isInvitee || isInviteeDirector
              ? setCurrentStepJointAccount
              : setCurrentStep
            : applicationType == 2
              ? setCurrentStepCorporate
              : setCurrentStepTrust
        }
      />
      {
        applicationType === 1 &&
        !isInvitee &&
        !isInviteeDirector && (
          <div className="flex h-full flex-col md:flex-row w-full mx-auto mt-6 overflow-hidden">
            <Sidebar
              steps={individualSteps}
              currentStep={currentStep}
              shareholderType={false}
              setCurrentStep={setCurrentStep}
            />
            <main className="w-full md:w-3/4 md:px-2">
              {renderStepContent()}
            </main>
          </div>
        )}

      {applicationType == 1 && (isInvitee || isInviteeDirector) && (
        <div className="flex  h-full flex-col md:flex-row w-full  mx-auto mt-6  overflow-hidden">
          <Sidebar
            steps={stepsJointAccount}
            currentStep={currentStepJointAccount}
            shareholderType={false}
            setCurrentStep={setCurrentStepJointAccount}
          />
          <main className="w-full md:w-3/4 md:px-2">
            {renderStepContentJointAccount()}
          </main>
        </div>
      )}
      {applicationType == 2 && (
        <div className="flex h-full flex-col md:flex-row w-full  mx-auto mt-6  overflow-hidden">
          <Sidebar
            steps={stepsCorporate}
            currentStep={currentStepCorporate}
            shareholderType={false}
            setCurrentStep={setCurrentStepCorporate}
          />
          <main className="w-full md:w-3/4 md:px-2">
            {renderStepContentCorporate()}
          </main>
        </div>
      )}
      {applicationType == 3 && (
        <div className="flex h-full flex-col md:flex-row w-full  mx-auto mt-6  overflow-hidden">
          <Sidebar
            steps={stepsTrust}
            currentStep={currentStepTrust}
            shareholderType={false}
            setCurrentStep={setCurrentStepTrust}
          />
          <main className="w-full md:w-3/4 md:px-2">
            {renderStepContentTrust()}
          </main>
        </div>
      )}
    </div>
  );
};

export default MultiStepSidebarForm;
